<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addMoneyTransferModal"
        persistent
        max-width="700px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              ><span class="headline">
                  Transfer Money
                </span></v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="isDone"
              >
                Done successfully
              </v-alert>

              <v-alert
                type="error"
                :value="errorAlert"
              >
                There is an error
              </v-alert>
              <v-layout wrap>
                <!-- <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <branch-select v-model="formData.branch_id_fk" />
                </v-flex> -->

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="banksList"
                    v-model="formData.from_bank_id_fk"
                    :error-messages="errors.collect('From Bank')"
                    data-vv-name="From Bank"
                    label="From Bank *"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="banksList"
                    v-model="formData.to_bank_id_fk"
                    :error-messages="errors.collect('To Bank')"
                    data-vv-name="To Bank"
                    label="To Bank *"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-text-field
                    label="Amount *"
                    v-model="formData.amount"
                    :error-messages="errors.collect('Amount')"
                    v-validate="'required'"
                    data-vv-name="Amount"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-text-field
                    label="Expense Amount *"
                    v-model="formData.expense_amount"
                    :error-messages="errors.collect('Expense Amount')"
                    v-validate="'required'"
                    data-vv-name="Expense Amount"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-text-field
                    label="Note"
                    v-model="formData.note"
                    :error-messages="errors.collect('Note')"
                    data-vv-name="Note"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >
                {{ isUpdate ? 'Save' : 'Add' }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'

export default {
  props: [
    'addMoneyTransferModal',
    'formData',
    'isUpdate',
    'banksList',
  ],

  data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false,
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          Axios.post('api/money_transfers', this.formData, {
            headers: { Authorization: 'Bearer ' + token },
          })
            .then(() => {
              this.errorAlert = false
              this.isDone = true
              setTimeout(() => {
                this.isDone = false
                this.$emit('resetTable')
                this.closeDialog()
              }, 1000)
            })
            .catch(() => {
              this.isDone = false
              this.errorAlert = true
              setTimeout(() => {
                this.errorAlert = false
              }, 1500)
            })
        }
      })
    },
  },
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/moneyTransfer/add.vue